import { render, staticRenderFns } from "./UntappdAuth.vue?vue&type=template&id=c174c496&"
import script from "./UntappdAuth.vue?vue&type=script&lang=js&"
export * from "./UntappdAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports